// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__2LEDf","label":"Section_label__2WWsf","contentWrap":"Section_contentWrap__1OuWt","footer":"Section_footer__24z2G","footerInner":"Section_footerInner__1cs63"};